import React from "react";

import { Stack } from "@mui/material";

import { GHOST_PREVIEW_OPACITY } from "../../../LiveFormEditor/LivePreview/ghostPreview.constant";

import { FormDivider } from "@/forms-design-system/FormDivider";

export type ThemedAdditionalQuestionsProps = {
  isPreview?: boolean;
  isGroupTicket?: boolean;
  children: React.ReactNode;
};

export const ThemedAdditionalQuestions = ({
  isPreview = false,
  isGroupTicket = false,
  children,
}: ThemedAdditionalQuestionsProps) => {
  return (
    <Stack
      direction="column"
      gap={2}
      divider={isGroupTicket ? <FormDivider /> : undefined}
      sx={{ opacity: isPreview ? GHOST_PREVIEW_OPACITY : undefined }}
      data-test="questions-one-rate"
    >
      {children}
    </Stack>
  );
};
